const addressToString = departmentAddress => {
  const { street, city, state, postcode, zip, country } = departmentAddress
  return `${street} ${city} ${state} ${postcode ?? ''} ${zip ?? ''} ${country ?? ''}`
}

export default addressToString
